import cookie from "@/assets/js/components/cookie";

const TOKEN_KEY = 'company_access_token';
const storage = {
    get(key) {
        return cookie.getCookie(key)
    },
    set(key, value) {
        cookie.setCookie(key, value)
    },
    remove(key) {
        cookie.deleteCookie(key)
    },
    getToken() {
        return this.get(TOKEN_KEY)
    },
    saveToken(accessToken) {
        this.set(TOKEN_KEY, accessToken)
    },
    removeToken() {
        this.remove(TOKEN_KEY)
    },
};

export default storage;
